// fork from https://github.com/kaorun343/vue-youtube-embed

const youtubeRegexp = /https?:\/\/(?:[0-9A-Z-]+\.)?(?:youtu\.be\/|youtube(?:-nocookie)?\.com\S*[^\w\s-])([\w-]{11})(?=[^\w-]|$)(?![?=&+%\w.-]*(?:['"][^<>]*>|<\/a>))[?=&+%\w.-]*/ig;

export default function getVideoIdFromURL(url) {
  let id = url.replace(youtubeRegexp, '$1');

  if (id.includes(';')) {
    const pieces = id.split(';');

    if (pieces[1].includes('%')) {
      const uriComponent = decodeURIComponent(pieces[1]);
      id = `http://youtube.com${uriComponent}`.replace(youtubeRegexp, '$1');
    } else {
      [id] = pieces;
    }
  } else if (id.includes('#')) {
    [id] = id.split('#');
  }

  return id;
}
